import React, { useContext } from "react";
import { LanguageContext } from "../../context/languageContext";
import { componentsNamesFactoryForTitle } from "../../Helper_functions/Languages/LanguageSelector";
import { LanguageIdContext } from "../../context/languageIdContext";

interface DialogBoxProps {}

export const DialogBox: React.FC<DialogBoxProps> = ({}) => {
    // context 
    
    const { languageId } = useContext(LanguageIdContext);
    let additionalInfoTitle = componentsNamesFactoryForTitle(languageId, "Additional Info");
    let closeButtonTitle = componentsNamesFactoryForTitle(languageId, "Close");

  return (
    <dialog id="questionDescriptionPopup" className="dialogBox">
      <div className="dialogBox-header">
        <h3>{additionalInfoTitle}</h3>
      </div>
      <div className="dialogBox-body">
        <div id="questionDescriptionText"></div>
      </div>
      <div id="questionDescriptionPopupClose" className="dialogBox-footer">
        <button type="button" className="dialogBox-close">
          {closeButtonTitle}
        </button>
      </div>
    </dialog>
  );
};
